// extracted by mini-css-extract-plugin
export default {"span":"span_span__KrA0N"};